export default __webpack_public_path__ + "static/cj-9ed7c5d5751976f822d0976d16aeec80.jpg";